import React from 'react'
import bite from 'app/assets/images/bite.png'
import styled from 'styled-components'

const Bite = () => {
    return (
        <BiteContainer>
            <BiteImage src={bite} />
        </BiteContainer>
    )
}

const BiteImage = styled.img`
    width: 15%;
`

const BiteContainer = styled.div`
    position: absolute;
    text-align: right;
    width: 100vw;
`

export { Bite }
